
export const root = {
    borderRadius: '{content.border.radius}',
    gap: '1rem'
};

export const meters = {
    background: '{content.border.color}',
    size: '0.625rem'
};

export const label = {
    gap: '0.5rem'
};

export const labelMarker = {
    size: '0.5rem'
};

export const labelIcon = {
    size: '1rem'
};

export const labelList = {
    verticalGap: '0.5rem',
    horizontalGap: '1rem'
};

export default {
    root,
    meters,
    label,
    labelMarker,
    labelIcon,
    labelList
};
